<template>
  <div class="gatherDetailApp" :style="'min-height:'+curHeight+'px;'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <ul>
      <li v-for="(item,i) in setGatherCard">
        <h2>{{item.title}}</h2>
        <p>总数：{{item.num}}次</p>
        <p>已用：{{item.useTotal}}次</p>
        <div class="expired" >剩余{{item.num - item.useTotal}}次</div>
      </li>
    </ul>
  </div>
</template>

<script> 
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        userData:[],
        baseUrl:'',
        code:'',
        setGatherCard:[]
      };
    },

    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var id = this.$route.query.id;
          var url = encodeURIComponent('http://user.4008005216.com/main/gatherdetail?id='+id);
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
        }
      }else{
        this.userData = JSON.parse(localStorage.getItem('userjwt'));
      }
    },
    mounted() {
      this.beforeMount();
      if(localStorage.getItem('userjwt') == null){
        this.login();
      }else{
        this.getGatherCard();
      }
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      getGatherCard:function(){
        var that = this;
        that.fullscreenLoading = true;
        var gather_id = that.$route.query.id;
        $.ajax({
          type:'post',
          url:that.$host+'home/gather/getGatherCard',
          data:{
            user_id:that.userData.id,
            gather_id:gather_id
          },
          dataType:'json',
          success:function(data){
            if(data.status == 200){
              that.setGatherCard = data.data;
            }else{
              that.$alert(data.message,'提示');
            }
            that.fullscreenLoading = false;
          }
        })
      },
      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          that.userData = res.data;
          that.getGatherCard();
          localStorage.setItem('userjwt', JSON.stringify(res.data));
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .gatherDetailApp{
    max-width:640px;
    margin:0 auto;
    background:#ececec;
  }
  
  .gatherDetailApp ul{
    width:96%;
    margin:0 auto;
    padding-top:12px
  }
  .gatherDetailApp ul li{
    background:#fff;
    margin-bottom:12px;
    border-radius:6px;
    padding:12px;
    position:relative;
  }
  .gatherDetailApp ul li h2{
    font-size:16px;
    color:#1C222B
  }
  .gatherDetailApp ul li p{
    font-size:14px;
    color:#3b3b3b;
    padding-top:6px
  }
  .gatherDetailApp ul li .expired{
    font-weight: bold;
    font-size: 14px;
    color: #E34D59;
    padding-top:6px
  }
</style>